module.exports = __webpack_public_path__ + "img/verified.7a284f09.svg";